import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=3589e6e8&scoped=true"
import script from "./CalendarList.js?vue&type=script&lang=js&external"
export * from "./CalendarList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589e6e8",
  null
  
)

export default component.exports